<template>
  <div>
    <div style="margin: 10px 0;display: flex;justify-content: space-between;align-items: center;">
      <p>广场列表</p>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addSquareFn" v-if="!addCard">
        新增广场
      </el-button>
    </div>
    <el-table :data="tableData" border style="width: 81vw">
      <el-table-column fixed type="index" label="序号" width="60" align="center">
      </el-table-column>
      <el-table-column fixed prop="id" label="ID" width="60" align="center">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column prop="name" label="广场名称"> </el-table-column>
      <el-table-column prop="sort" align="center" label="排序" width="60">
      </el-table-column>
      <el-table-column prop="circleCount" align="center" label="圈子数量" width="120" >
        <template slot-scope="scope">
          <el-button size="small" >{{ scope.row.circleCount || 0 }}</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.state ? 'danger' : 'success'">
            {{ scope.row.state ? "隐藏" : "正常" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="checkSuqareFn(scope.row)" type="text" size="small">查看所属圈子</el-button>
          <el-button v-if="!addCard"  @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
          <el-button v-if="!addCard" size="small" type="text" @click.native.prevent="removeClick(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin: 20px 20px 0 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchForm.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next" :total="total_pages">
      </el-pagination>
    </div>
    <!-- 创建广场对话框 -->
    <el-dialog :append-to-body="true" :title="nowShow === 'add' ? '创建广场' : '修改信息'" :visible.sync="centerDialogVisible"
      width="30%" center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="广场名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入广场名称"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input type="number" v-model="ruleForm.sort" placeholder="请输入排序序列"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="state">
          <el-select v-model="ruleForm.state">
            <el-option label="显示" :value="0"></el-option>
            <el-option label="隐藏" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">
            {{ nowShow === 'add' ? '创建' : '修改' }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="# 圈子列表" :append-to-body="true" width="80%" :visible.sync="circleDialogVisible">
      <circleListPage v-if="circleDialogVisible" :squareId="squareId" :addCard="addCard" @selectCircle="selectCircle"></circleListPage>
    </el-dialog>
  </div>
</template>
<script>
import { GetSquaerApi, newSquaerApi, removeSquaerApi } from "@/api/user.js";
import circleListPage from '@/views/circle/index.vue'
export default {
  name: "squAre",
  components: {
    circleListPage
  },
  props: {
    addCard: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableData: [],
      circleDataList: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
      },
      centerDialogVisible: false,
      ruleForm: { name: "", state: 0, sort: "" },
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { max: 6, trigger: "blur", message: "名称长度不能超过6个字符" },
          { validator: this.valinameValue, trigger: "blur" },
        ],
        state: [
          { required: true, message: "请选择是否显示", trigger: "change" },
        ],
        sort: [
          { required: true, message: "请输入排序优先级", trigger: "change" },
          { validator: this.validateValue, trigger: "blur" },
        ],
      },
      circleDialogVisible: false,
      total_pages: 0,
      nowShow: 'add',
      squareId: ''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    selectCircle(row){
      this.$emit('selectCircle', row)
      this.circleDialogVisible = false;
    },
    checkSuqareFn(row) {
      this.squareId = row.id
      this.circleDialogVisible = true
    },
    addSquareFn() {
      this.ruleForm = { name: "", state: 0, sort: "" }
      this.centerDialogVisible = true
      this.nowShow = 'add'
    },
    getList() {
      GetSquaerApi(this.searchForm).then((res) => {
        this.tableData = res.data.records;
        this.total_pages = res.data.total;
      });
    },
    handleCurrentChange(number) {
      this.searchForm.pageNum = number;
      this.getList();
    },
    handleSizeChange(size) {
      if (this.total_pages >= size) {
        this.searchForm.pageSize = size;
        this.getList();
      } else {
        this.$message.error("每页显示数量不能超过总页数!");
      }
    },
    // 删除该广场
    removeClick(row) {
      this.$confirm("此操作将删除该广场, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeSquaerApi(row.id)
            .then(() => {
              this.$message({ type: "success", message: "删除成功!" });
              this.getList();
            })
            .catch(() => {
              this.$message.error("删除失败!");
            });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消删除" });
        });
    },
    // 表格当前被单击行的内容
    handleClick(row) {
      this.nowShow = 'edit'
      this.centerDialogVisible = true;
      this.ruleForm = { ...row };
    },
    // 表单验证
    validateValue(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入0-100的数值"));
      } else if (value > 100) {
        callback(new Error("数值最大为100"));
      } else {
        callback();
      }
    },
    valinameValue(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入数值"));
      } else if (value.length < 2) {
        callback(new Error("请输入两位数以上的名称"));
      } else {
        callback();
      }
    },
    // 创建广场事件
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const res = await newSquaerApi(this.ruleForm);
            if (res.code == 200) {
              this.$message.success(res.msg ? res.msg : '创建成功');
              this.ruleForm = { name: "", state: 0, sort: "" };
              this.centerDialogVisible = false;
              this.getList();
            } else {
              this.$message.error(res.msg ? res.msg : '创建失败');
            }
          } catch (error) {
            this.$message.error(error ? error : '创建失败');
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style></style>
